import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import useFaqs from "../../Hooks/useFaqs";
import Loading from "../../components/LoadingPage/Loading";
import "./userGuideShare.scss";

const RecursiveAccordion = ({
    guides,
    depth = 0,
}: {
    guides: any[];
    depth?: number;
}) => {
    if (!guides || guides.length === 0) return null;

    return (
        <div className={`accordion ${depth > 0 ? "nested-accordion" : ""}`}>
            {guides.map((guide: any) => {
                const hasChildren =
                    guide?.childUserGuides && guide.childUserGuides.length > 0;

                return (
                    <div className="accordion-item" key={guide?.id}>
                        <h2 className="accordion-header">
                            <button
                                className="accordion-button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target={`#guide-${guide?.id}`}
                                aria-expanded="false"
                                aria-controls={`guide-${guide?.id}`}
                            >
                                {guide?.title || ""}
                            </button>
                        </h2>
                        <div
                            id={`guide-${guide?.id}`}
                            className="accordion-collapse collapse"
                        >
                            <div className="accordion-body">
                                {guide?.description && (
                                    <div
                                        dangerouslySetInnerHTML={{ __html: guide.description }}
                                    />
                                )}
                                {hasChildren && (
                                    <RecursiveAccordion
                                        guides={guide.childUserGuides}
                                        depth={depth + 1}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

const UserGuideShare = () => {
    const { id } = useParams<{ id: string }>();
    const { getUserGuideByIdAPI, getUserGuideByIdLoading } = useFaqs();
    const [guide, setGuide] = useState<any>(null);
    const [error, setError] = useState<string>("");

    useEffect(() => {
        if (id) {
            getUserGuideByIdAPI({ id })
                .then(setGuide)
                .catch((err: any) => setError(err?.message || "Failed to load guide."));
        }
    }, [id]);

    if (getUserGuideByIdLoading) return <Loading />;

    return (
        <div className="user-guide-share-wrapper">
            <div className="user-guide-share-content-box">
                {error ? (
                    <p className="user-guide-share-error">{error}</p>
                ) : guide ? (
                    <>
                        <h2 className="user-guide-share-title">{guide.title}</h2>
                        {guide.description && (
                            <div
                                className="user-guide-share-body"
                                dangerouslySetInnerHTML={{ __html: guide.description }}
                            />
                        )}
                        {guide.childUserGuides && guide.childUserGuides.length > 0 && (
                            <div className="user-guide-share-accordion">
                                <RecursiveAccordion guides={guide.childUserGuides} />
                            </div>
                        )}
                    </>
                ) : null}
            </div>
        </div>
    );
};

export default UserGuideShare;
